module.exports = __webpack_public_path__ + "img/green-carpet-grass-10.d76d2096.png";